"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gray = void 0;
exports.gray = {
    c10: '#24252E',
    c20: '#3A3A47',
    c30: '#515162',
    c40: '#696979',
    c50: '#7A7B8E',
    c60: '#8F8FA2',
    c70: '#AAAAB9',
    c80: '#D3D4DD',
    c90: '#F0F0F5',
    c100: '#FFFFFF',
};
//# sourceMappingURL=gray.js.map